import MedicalProfessionalsLanding from "@/components/landing/medical-professionals";
import PersonaStaticRoute from "@/components/landing/persona-static-route";
import { getPersonaPageProps } from "@/lib/persona-pages.server";

export default function PersonaPageRoute(props: any) {
  return (
    <PersonaStaticRoute
      {...props}
      Landing={MedicalProfessionalsLanding}
      title="Level 7 Aesthetics for Medical Professionals | VTCT Skills"
      description="VTCT Skills (ITEC) Level 7 injectable routes for doctors, dentists, nurses and regulated healthcare professionals: MA7D1, MA7D2 RPEL and MA7C1."
    />
  );
}

export async function getStaticProps() {
  const props = await getPersonaPageProps({
    pagePath: "/courses/medical-professionals/",
    courseUrls: [
      "/courses/vtct/level-7-diploma-in-clinical-aesthetic-injectable-treatments",
      "/courses/vtct/level-7-diploma-in-non-surgical-cosmetic-injectable-treatments",
      "/courses/vtct/level-7-certificate-in-bio-stimulatory-injectable-treatments",
    ],
  });
  return { props, revalidate: 3600 };
}
